import {
  getAnchor,
  getHotel,
  getSearchId,
  getSearchParameters
} from 'modules/sapiSearch/selectors'
import objectHash from 'object-hash'
import {getUserSearchHistory, setUserSearchHistory} from 'utils/persistence'

import {isBrowser} from '@vio/core/src/_web/utils/environment'
import {warnServerEnvironment} from '@vio/core/src/_web/utils/logging/server-warning'

import type {AppThunk} from 'store'

const MAX_USER_SEARCH_HISTORY_COUNT = 10

const saveUserSearchHistory = (): AppThunk => (dispatch, getState) => {
  if (!isBrowser) {
    warnServerEnvironment(`saveUserSearchHistory`)
    return undefined
  }

  const searchParams = getSearchParameters(getState())
  const anchor = getAnchor(getState())
  const searchId = getSearchId(getState())

  const {checkIn, checkOut, hotelId, placeId, rooms} = searchParams
  const hotel = getHotel(getState(), hotelId)
  const imageURI = hotel?.imageURIs?.[0]

  const searchData = {
    ...anchor,
    hotelImageUrl: imageURI
  }

  const historyId = objectHash({
    checkIn,
    checkOut,
    hotelId,
    placeId,
    rooms
  })

  let userSearchHistory = getUserSearchHistory(
    MAX_USER_SEARCH_HISTORY_COUNT,
    false
  )

  userSearchHistory = userSearchHistory
    .filter(history => history.historyId !== historyId)
    // filters all the userLocationSearch=1 (Nearby)
    // TODO (@search): Provide support for Gelocation search in Carousel widgets
    .filter(history => history.searchData.objectType !== 'point')

  // Prevent adding a userLocationSearch=1 (Nearby) search to the history
  // TODO (@search): Provide support for Gelocation search in Carousel widgets
  if (searchData.objectType !== 'point') {
    userSearchHistory.unshift({
      historyId,
      searchParams,
      searchData,
      searchId
    })
  }

  setUserSearchHistory(
    userSearchHistory.slice(0, MAX_USER_SEARCH_HISTORY_COUNT)
  )
}

export default saveUserSearchHistory
